import * as yup from "yup";

export interface FeatureToggle {
	/**Unique for Product Id */
	productId: string;

	/**Unique Identifier for Feature Toggle */
	featureToggleId: string;

	/**Feature Toggle Name */
	name: string;

	/**Display Name for Feature Toggle */
	displayName: string;

	/**Unique Identifier for Deployment Ring */
	deploymentRingId: string;

	/**Navigation property for Deployment Ring */
	deploymentRing: DeploymentRing;

	/**List of Product Tiers */
	productTiers: FeatureToggleProductTier[];

	/**List of Product Names - used to show comma separated list */
	productTierNames: string;

	/**Created DateTime */
	created: Date | string;

	/**Created by Username */
	createdBy: string;

	/**Update DateTime */
	updated: Date | string;

	/**Updated by Username */
	lastUpdatedBy: string;
}

export interface DeploymentRing {
	/**Unique identifier for Deployment Ring. */
	id: string;

	/**Deployment Ring Name. */
	name: string;
}

export interface FeatureToggleProductTier {
	/**Unique Identifier for Product Tier */
	id: string;

	/**Display name of the Product Tier */
	name: string;

	/**Indicator if Feature Toggle is enabled for the Product Tier */
	isEnabled: boolean;
}

export interface FeatureToggleEditRequest {
	/**Unique Identifier for Feature Toggle */
	featureToggleId?: string;

	/**Feature Toggle Name */
	name: string;

	/**Display Name for Feature Toggle */
	displayName: string;

	/**Unique Identifier for Deployment Ring */
	deploymentRingId: string;

	/**List of Product Tiers */
	productTierIds: string[];
}

export const FeatureToggleEditRequestInitialValue: FeatureToggleEditRequest = {
	featureToggleId: "",
	name: "",
	displayName: "",
	deploymentRingId: "",
	productTierIds: [],
};

export const FeatureToggleEditRequestValidationSchema = yup.object().shape({
	name: yup.string().required().max(250).label("name"),
	displayName: yup.string().required().max(250).label("display name"),
	deploymentRingId: yup.string().required().label("deployment ring"),
	productTierIds: yup.array().of(yup.string()),
});
